import {
  getSystemDictListApi,
  queryDeliveryCompanyListApi
} from '@/api';
import { defineStore } from 'pinia';

const useSystemStore = defineStore('system', {
  state: () => {
    return {
      isLoading: false,

      previewList: [],
      previewImageListVisible: false,

      regionData: [],

      videoDialogVisible: false, // 视频预览
      videoUrl: null,

      // deliveryCompanyList: [],
    };
  },
  actions: {
    // 设置loading
    setLoading(isLoading) {
      this.isLoading = isLoading;
    },

    // 关闭图片
    closePreviewList() {
      this.previewImageListVisible = false;
      this.previewList.splice(0);
    },
    // 打开图片预览
    openPreviewList(list) {
      this.previewList = list;
      this.previewImageListVisible = true;
    },
    // 关闭视频
    closeVideoPreview() {
      this.videoDialogVisible = false;
      this.videoUrl = null;
    },
    // 打开视频预览
    openVideoPreview(videoUrl) {
      this.videoUrl = videoUrl;
      this.videoDialogVisible = true;
    },
    // 初始化省市区
    async initRegionData() {
      const resp = await getSystemDictListApi();
      if (resp.code == 200) {
        this.regionData = resp.data;
      }
    },
    async initDeliveryCompanyList() {
      const resp = await queryDeliveryCompanyListApi();
      if (resp.code == 200) {
        this.deliveryCompanyList = resp.data;
      }
    },
  },
});

export default useSystemStore;
